export class EnvService {
  // Los valores que sean definidos aqui son los valores por defecto
  // que pueden ser sobreescritos por evn.js

  // API url
  public apiUrl = '';

  // Habilitar o no el modo debug. 
  public enableDebug = true;

  constructor() {
  }

}